var OwnApproval = function () { return import('~/pages/approval-manage/own-approval.vue'); };
var ApprovalTask = function () { return import('~/pages/approval-manage/approval-task.vue'); };
var ApprovalCategory = function () { return import('~/pages/approval-manage/approval-category.vue'); };
export default [
    {
        // 我的审核
        path: '/approval-manage/own-approval',
        name: 'own-approval',
        component: OwnApproval,
    },
    {
        // 审批类型设置
        path: '/approval-manage/approval-category',
        name: 'approval-category',
        component: ApprovalCategory,
    },
    {
        // 审批流程设置
        path: '/approval-manage/approval-task',
        name: 'approval-task',
        component: ApprovalTask,
    }
];
